module.exports = __webpack_public_path__ + "static/img/icon4-8.6c20ceb3.png";